<template lang="pug">
  component(
    v-if='component && track'
    :is='component'
    :track='track'
    :playlist-id='playlistId'
    :running='trackRunning'
    :removable='removable'
    :disabled='disabled'
    :checkable='checkable'
    :checked='checked'
    :show-controls='showControls'
    :disable-link='disableLink'
    :editable-title='editableTitle'
    :hide-cover='hideCover'
    :in-queue='inQueue'
    @play='play'
    @pause='pause'
    @delete='deleteTrack'
    @restore='restoreTrack'
    @like='likeTrack'
    @unlike='unlikeTrack'
    @rename='renameTrack'
  )
</template>
<script>
import { mapActions } from "vuex";

import dinamicComponentMixin from "@/mixins/shared/dinamicComponent.mixin";
import playerControlsMixin from "@/mixins/shared/playerControls.mixin";

import cardTemplate from "./templates/card";
import listTemplate from "./templates/list";
import smallTemplate from "./templates/small";
import fullTemplate from "./templates/full";

export default {
  props: {
    showControls: {
      type: Boolean,
      default: true
    },
    disableLink: {
      type: Boolean,
      default: false
    },
    editableTitle: {
      type: Boolean,
      default: false
    },
    hideCover: {
      type: Boolean,
      default: false
    },
    inQueue: {
      type: Boolean,
      default: false
    },
    track: Object,
    tracklist: Object,
    playlistId: String,
    remove: Function,
    editable: Boolean,
    removable: Boolean,
    checkable: Boolean,
    checked: Boolean
  },
  data() {
    return {
      disabled: false,
      templates: {
        card: cardTemplate,
        list: listTemplate,
        small: smallTemplate,
        full: fullTemplate
      }
    };
  },
  mixins: [playerControlsMixin, dinamicComponentMixin],
  computed: {
    trackRunning() {
      return Boolean(this.running && this.currentTrackId === this.track.id);
    }
  },
  methods: {
    ...mapActions({
      delete: "tracks/delete",
      rename: "tracks/rename",
      like: "tracks/like",
      unlike: "tracks/unlike"
    }),
    deleteTrack() {
      if (this.checkable) {
        return this.$emit("check");
      }

      this.disabled = true;
      this.delete({ ids: [this.track.id] }).then(() => {
        this.disabled = false;
      });
    },
    restoreTrack() {
      this.$emit("uncheck");
    },
    likeTrack() {
      this.like(this.track.id);
    },
    unlikeTrack() {
      this.unlike(this.track.id);
    },
    renameTrack(title) {
      this.rename({ id: this.track.id, title });
      this.$emit("rename", { id: this.track.id, title });
    }
  }
};
</script>
